import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment-jalali';

const initialValues = {
    title: '',
    issueDay: 0,
    subGuildId: ''
};

const issuList = [
    {
        value: 1,
        label: "بله"
    }, {
        value: 2,
        label: "خیر"
    }
]


const validationSchema = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است ")
});


const validationSchemaIssueDay = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است "),
    issueDay: Yup.string()
        .test('issueDay', "لطفا فقط عدد وارد کنید (با صفر شروع نکنید)", value => {
            return /^[0-9]+$/.test(value) && !value.startsWith('0') && value >= 1 && value <= 100;
        }),
});


const Create = () => {

    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);
    const [issueType2, setIssueType2] = useState(0);
    const [checkComment, setCheckComment] = useState(false);
    const [file, setFile] = useState('');

    const { addData } = useEntityCrud('Opinions/SetOpinion');
    const navigate = useNavigate();


    const { readData } = useEntityCrud('Guild/GetAllGuilds');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        readData().then(({ data }) => {
            if (data.status) {
                let guilds = data.result.filter(item => item.isActive);
                setOptions(guilds);
            }
        });
    }, []);



    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    }


    useEffect(() => {
        setTodate("")
    }, [fromdate])


    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true,
            "fromdate": convertToDate(fromdate),
            "todate": ((parseInt(issueType2) != 1) ? convertToDate(todate) : convertToDate(fromdate)) || "2023-06-17T10:41:13.791Z",
            "createDate": convertToDate(fromdate),
            "issueType": (parseInt(values.issueType) === 1 ? 0 : 1) || 0,
            "issueDay": (parseInt(issueType2) != 1) ? 0 : parseInt(values.issueDay),
            "guildId": parseInt(values.guildId),
            "subGuildId": parseInt(values.subGuildId) || 0,
            "smsInterval": (parseInt(values.smsInterval)) || 0,
            "openComment": checkComment,
            "logo": file || ""

        };
        addData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('نظرسنجی جدید با موفقیت ایجاد شد');
                return navigate('/survey');
            }
            else
                toast.error(data.message);
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));

    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });


    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد نظرسنجی جدید</div>
                <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    file={file}
                    setFile={setFile}
                    isEditMode={false}
                    fromdate={fromdate} setFromdate={setFromdate}
                    todate={todate} setTodate={setTodate} issuList={issuList}
                    setOptions={setOptions} options={options}
                    checkComment={checkComment} setCheckComment={setCheckComment}
                    issueType2={issueType2} setIssueType2={setIssueType2} />
            </div>
        </div>
    );
}

export default Create;